// DESCRIPTION: Admin wrapper component for editing an existing event.
// Delegates to EventFormWizard in 'edit' mode and handles save/cancel callbacks.
import EventFormWizard from './wizard/EventFormWizard';

/**
 * Edit Event Form
 *
 * Wrapper around EventFormWizard for editing events in the admin SPA.
 *
 * @param {Object}   props
 * @param {number}   props.eventId  - The ID of the event to edit.
 * @param {Function} props.onSave   - Called after the event is successfully updated.
 * @param {Function} props.onCancel - Called when the user cancels editing (navigates back).
 */
const EditEventForm = ( { eventId, onSave, onCancel } ) => {
	return (
		<EventFormWizard
			mode="edit"
			eventId={ eventId }
			onSave={ onSave }
			onCancel={ onCancel }
		/>
	);
};

export default EditEventForm;
